import { Banner } from "@freightsimple/ui-core/Display/Banner";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { FilePdfIcon } from "@phosphor-icons/react/FilePdf";
import type { UUID } from "@/Shared/types";

import { useUploadCustomsDocsDialog } from "@/Shared/Shipment/Dialogs/ShipmentUploadCustomsDocsDialog";

interface CustomsDocsSectionForTrackingProps {
  trackingId: UUID;
  onUploaded: () => void;
}

export function ShipmentCustomsDocsSectionForTracking(
  props: CustomsDocsSectionForTrackingProps,
) {
  const uploadCustomsDocsDialog = useUploadCustomsDocsDialog(props.trackingId);

  async function onUpload() {
    const uploaded = await uploadCustomsDocsDialog.show();

    if (uploaded) {
      await props.onUploaded();
    }
  }

  return (
    <div className="mb-4 w-full">
      {uploadCustomsDocsDialog.dialogs}
      <Banner
        variant="warning"
        title="Missing Customs Documents"
        actions={
          <Button primary icon={FilePdfIcon} onClick={onUpload}>
            Upload PDF
          </Button>
        }
      >
        Without customs documents, shipments can be delayed at pickup and
        in-transit.
      </Banner>
    </div>
  );
}
